/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorEvaluationResponse } from './aiTutorEvaluationResponse';

export type GenericApiResponseAiTutorEvaluationResponseData = AiTutorEvaluationResponse | null;
